module.exports = __webpack_public_path__ + "static/img/BY-S02.cb6f29a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/BY-S02/BY-S02.png
// module id = cAPS
// module chunks = 0